import { CurrencyKeyType } from './app.constants';

export const NAME_REGEX = /^[\w\s\-'ÆØÅ]+$/i;
export const NAME_MAX_LENGTH = 32;
export const EMAIL_REGEX =
  /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+\.[a-z]{2,}(?:\.[a-z]{2,})*$/i;
export const PHONE_REGEX = /^[- +()0-9]+$/;
export const CARD_NUMBER_REGEX = /^([\d]{4}[ -]*){4}$/;
export const CARD_CVV_REGEX = /^[\d]{3,4}$/;
export const BILLING_ZIP_REGEX = /^[a-z\d\-_\s]+$/i;
// characters other than this will be skipped over in date input masks
export const OVERWRITEABLE_DATE_MASK_CHARACTERS_REGEX = /[^-/\\]/i;
export const DECIMAL_CHARACTER_REGEX = /\d/;
export const ALL_NUMBERS_REGEX = /\d/g;
export const ALPHANUMERIC_REGEX = /[\da-zA-Z]*/g;

export const INVALID_DATE_KEY = 'invalidDate';
export const PASSPORT_EXPIRATION_INVALID_DATE_KEY = 'passportExpirationInvalidDate';
export const PASSPORT_ISSUED_INVALID_DATE_KEY = 'passportIssuedInvalidDate';
export const INFANT_INVALID_DATE_KEY = 'infantInvalidDate';
export const DATE_OUT_OF_RANGE_KEY = 'dateOutOfRange';
export const INFANT_DATE_OUT_OF_RANGE_KEY = 'infantDateOutOfRange';
export const PASSPORT_EXPIRATION_DATE_OUT_OF_RANGE_KEY = 'passportExpirationDateOutOfRange';
export const PASSPORT_ISSUED_DATE_OUT_OF_RANGE_KEY = 'passportIssuedDateOutOfRange';
export const REQUIRED_LENGTH_KEY = 'requiredLength';
export const MAX_LENGTH_KEY = 'maxLength';
export const MIN_LENGTH_KEY = 'minLength';
export const MIN_KEY = 'min';
export const MAX_KEY = 'max';
export const REQUIRED_KEY = 'required';
export const FORBIDDEN_NAME_KEY = 'forbiddenName';
export const PATTERN_KEY = 'pattern';
export const BS_DATE_KEY = 'bdDate';

export const MAX_DATE_VALUE_KEY = 'maxDate';
export const MIN_DATE_VALUE_KEY = 'minDate';
export const MAX_VALUE_KEY = 'max';
export const MIN_VALUE_KEY = 'min';

export const CARD_EXPIRATION_FIELD_KEY = 'cardExpiration';
export const MIN_AGE_CONTACT_DATA_COLLECTION = 14;
export const TOTAL_ERROR_KEY = 'total';
export const VOUCHER_CODE_LENGTH = 17;
export const CREDIT_FILE_CODE_LENGTH = 6;

export const MAX_SINGLE_PAYMENT_AMOUNTS_BY_CURRENCY: {
  [key in CurrencyKeyType]: number;
} = {
  USD: 20000,
  EUR: 19000,
  GBP: 16000,
  NOK: 190000,
  ZAR: 330000,
  SEK: 190000
};

export const PASSPORT_EXPIRATION_DATE = 'passportExpirationDate';
export const PASSPORT_ISSUED_DATE = 'passportIssuedDate';
export const PASSPORT_EXPIRATION_DAY = 'passportExpirationDay';
export const PASSPORT_EXPIRATION_MONTH = 'passportExpirationMonth';
export const PASSPORT_EXPIRATION_YEAR = 'passportExpirationYear';
export const PASSPORT_ISSUED_DAY = 'passportIssuedDay';
export const PASSPORT_ISSUED_MONTH = 'passportIssuedMonth';
export const PASSPORT_ISSUED_YEAR = 'passportIssuedYear';
export const INFANT_PASSPORT_EXPIRATION_DATE = 'infantPassportExpirationDate';
export const INFANT_PASSPORT_EXPIRATION_DAY = 'infantPassportExpirationDay';
export const INFANT_PASSPORT_EXPIRATION_MONTH = 'infantPassportExpirationMonth';
export const INFANT_PASSPORT_EXPIRATION_YEAR = 'infantPassportExpirationYear';
export const INFANT_PASSPORT_ISSUED_DATE = 'infantPassportIssuedDate';
export const INFANT_PASSPORT_ISSUED_DAY = 'infantPassportIssuedDay';
export const INFANT_PASSPORT_ISSUED_MONTH = 'infantPassportIssuedMonth';
export const INFANT_PASSPORT_ISSUED_YEAR = 'infantPassportIssuedYear';
